import { createSlice, createSelector } from '@reduxjs/toolkit';
import { getAboutUsPage, getEmployees } from 'api/AboutUs';
import { fetchWithLanguage } from 'store/helpers';

export const fetchAboutUs = fetchWithLanguage('fetchAboutUs', getAboutUsPage);
export const fetchEmployees = fetchWithLanguage('fetchEmployees', getEmployees);

const aboutUsSlice = createSlice({
    name: 'aboutUsSlice',
    initialState: {
        about: {},
        employees: {
            data: [],
            next: false,
        },
    },
    reducers: {},
    extraReducers: builder => {
        builder.addCase(fetchAboutUs.fulfilled, (state, action) => {
            state.about = action.payload;
        });
        builder.addCase(fetchEmployees.fulfilled, (state, action) => {
            const { payload } = action;
            state.employees.next = payload.next;
            state.employees.data.push(...payload.data);
        });
    },
});

export const selectAboutUsPage = createSelector([state => state.aboutUsState.about], about => about.data || {});

export const selectEmployees = createSelector([state => state.aboutUsState.employees], employees => employees);

export default aboutUsSlice.reducer;
